import { APP_ROLES } from "../utilities/constants";

export const getDefaultURLForRole = (roleId) => {
	const f = APP_ROLES.find((obj) => obj.roleId === roleId);
	return f ? f.defaultURL : "/";
};
